import { render, staticRenderFns } from "./Muqu.vue?vue&type=template&id=cbd2d5c6&"
import script from "./Muqu.vue?vue&type=script&lang=js&"
export * from "./Muqu.vue?vue&type=script&lang=js&"
import style0 from "./Muqu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports